import type { SplitFlags } from '@bo-types/splitFlags';
import { useSplitTreatments } from '@splitsoftware/splitio-react';

export function useSplitFlag({ flagName }: { flagName: SplitFlags }): {
  isActive: boolean;
  isReady: boolean;
  treatment?: string;
} {
  const { isReady, treatments } = useSplitTreatments({ names: [flagName] });

  return {
    isActive: isReady && treatments[flagName].treatment === 'on',
    isReady,
    treatment: treatments[flagName].treatment
  };
}
